<template>
  <div class="">
    <div class="row">
      <div class="col-md-6">
        <h1>Help & Support</h1>
      </div>
      <div class="col-md-6 text-right mt-20">
        <button class="btn btn-primary" @click="showFeedbackModal">Give Product Feedback</button>
      </div>
    </div>

    <div class="panel panel-default">
      <div class="panel-body">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="mt-0"><strong>Welcome</strong></h3>
            <p>
              Welcome to the CapsimInbox Authoring Platform support page. If you're new, the Author
              Guide is a great place to start. Not finding what you're looking for? Don't hesitate
              to reach out to our team at
              <a href="mailto:authoring@capsim.com">authoring@capsim.com</a>.
            </p>
          </div>
        </div>

        <hr />

        <file-section
          v-for="(section, idx) in sections"
          v-bind="section"
          :key="`section-${idx}`"
        ></file-section>
        <hr />
        <div class="text-center" style="width: 100%">
          <div style="margin: 0 auto; display: inline-block">
            <div class="media">
              <div class="media-left">
                <img
                  height="80px"
                  src="/capsiminbox/images/Inbox-Megaphone.svg"
                  alt="Product Updates"
                />
              </div>
              <div style="vertical-align: middle; width: auto" class="media-body">
                <p class="mb-0">
                  Want to see what we’ve been working on? Check out what’s new with CapsimInbox
                  <a
                    target="_blank"
                    href="https://www.capsim.com/blog/category/capsiminbox-enhancements/"
                    >here</a
                  >.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <customer-feedback :key="feedbackReRenderKey" :isOpen="isFeedbackOpen" />
  </div>
</template>

<script>
  import Section from './Section.vue';
  import CustomerFeedback from './CustomerFeedback';
  import uuid from 'uuid';
  export default {
    name: 'HelpAndSupport',

    components: {
      FileSection: Section,
      CustomerFeedback,
    },

    data() {
      return {
        feedbackReRenderKey: 0,
        isFeedbackOpen: false,
        sections: [
          {
            sectionName: 'Getting Started Resources',
            addSecBreak: false,
            files: [
              {
                name: 'Onboarding Video',
                fileName: '/capsiminbox/resources/Authoring_Welcome_Update.mp4',
                fileType: 'Video',
                description: 'A video to get you started using the tool.',
              },
              {
                name: 'Author Guide',
                fileName: 'IAP_author_guide_v2.1.pdf',
                fileType: 'PDF',
                description: 'An overview of key functionality in the platform.',
              },
              {
                name: 'Sharing Your Inbox',
                fileName: 'CapsimInbox-Authoring-Platform_Sharing-Your-Inbox.pdf',
                fileType: 'PDF',
                description: 'A guide for publishing your Inbox and providing access to users.',
              },
              {
                name: 'Participant Experience',
                fileName: 'The_CapsimInbox_Participant_experience_v1_Final.pdf',
                fileType: 'PDF',
                description: 'A step-by-step walkthrough of what your end user will experience.',
              },
              {
                name: 'Scoring Your Inbox',
                fileName: 'CapsimInbox-AP_Scoring.pdf',
                fileType: 'PDF',
                description: 'A guide for assigning skill points and creating your scoring scale.',
              },
              {
                name: 'Creating ADA Compliant Materials',
                fileName: 'CapsimInbox-AP_ADA-Material-Guidance_v1.pdf',
                fileType: 'PDF',
                description:
                  'A guide for creating content that will comply with the Americans with Disabilities Act.',
              },
            ],
          },
          {
            sectionName: 'Resources to Share',
            addSecBreak: true,
            files: [
              {
                name: 'Getting Started With Your Inbox',
                fileName: 'CapsimInbox-Authoring-Platform-Getting-Started-With-Your-Inbox.pdf',
                fileType: 'PDF',
                description:
                  'A material to share with users that walks through the steps of signing up and accessing your Inbox.',
              },
            ],
          },
        ],
      };
    },
    methods: {
      showFeedbackModal() {
        // assign random unique key to re-render modal for form reset
        this.feedbackReRenderKey = uuid.v4();
        this.isFeedbackOpen = true;
      },
    },
  };
</script>
